module.exports = __webpack_public_path__ + "img/21.f3eab5dd.jpg";